import hexOpacity from 'hex-opacity';

export const blue = "#00A1ED";
export const pink = "#E0007A";
export const grey = "#404040";

export const lightBlue = hexOpacity.create(blue, 0.5)
export const lightPink = hexOpacity.create(pink, 0.5)
export const lightGrey = hexOpacity.create(grey, 0.5)
